/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./select-payment.vue?vue&type=template&id=1a0165a8&scoped=true"
import script from "./select-payment.vue?vue&type=script&lang=js"
export * from "./select-payment.vue?vue&type=script&lang=js"
import style0 from "./select-payment.vue?vue&type=style&index=0&id=1a0165a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0165a8",
  null
  
)

export default component.exports